export default "__VITE_ASSET__BJj$w1tn__"